import { z } from 'zod'
import { Model } from './architecture'

export const TokenValidation = z.object({
  value: z.string({ required_error: '[Token] value is required' }),
})

export class Token extends Model {
  static create({ value }: z.infer<typeof TokenValidation>) {
    TokenValidation.parse({ value })
    return new Token(value)
  }
  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
